module.exports = __webpack_public_path__ + "static/media/street-art.2aaa9789.png";